const heart = '<svg aria-hidden="true"><use href="#i-heart"/></svg>';

/** Persistent life slots plus a short, enlarged split-heart effect after mistakes. */
export class LivesView {
  constructor(host, {
    reducedMotion = () => matchMedia("(prefers-reduced-motion: reduce)").matches,
  } = {}) {
    this.host = host;
    this.reducedMotion = reducedMotion;
    host.innerHTML = Array.from(
      { length: 3 },
      () => `<span class="life-heart" aria-hidden="true">${heart}</span>`,
    ).join("");
    this.slots = [...host.children];
    this.previous = null;
  }
  render(remaining, mistake = false) {
    this.slots.forEach((slot, index) =>
      slot.classList.toggle("spent", index >= remaining),
    );
    this.host.setAttribute("aria-label", `${remaining} lives remaining`);
    if (
      mistake && this.previous !== null &&
      remaining < this.previous && !this.reducedMotion()
    ) {
      for (let index = remaining; index < this.previous; index++)
        this.breakHeart(this.slots[index]);
    }
    this.previous = remaining;
  }
  breakHeart(slot) {
    const bounds = slot.getBoundingClientRect();
    const burst = document.createElement("span");
    burst.className = "heart-burst";
    burst.setAttribute("aria-hidden", "true");
    burst.style.left = `${Math.max(68, Math.min(innerWidth - 68, bounds.left + bounds.width / 2)) - 16}px`;
    burst.style.top = `${bounds.top + bounds.height / 2 - 16}px`;
    burst.innerHTML = `<span class="heart-piece heart-piece-left">${heart}</span><span class="heart-piece heart-piece-right">${heart}</span>`;
    burst.addEventListener("animationend", () => burst.remove(), { once: true });
    this.host.append(burst);
  }
  destroy() {
    for (const burst of this.host.querySelectorAll(".heart-burst")) burst.remove();
  }
  refreshMotion() {
    if (this.reducedMotion()) this.destroy();
  }
}
